import { useEffect } from "react";
import {
    POSTAL_CHANNEL_T1_GRADE_PAGE_COMPONENTS,
    POSTAL_TOPIC_COLOR_CHANGED,
} from "../../../../common-deprecated/constants";
import { getPostal } from "../../../../common-deprecated/utils/postalUtils";
import { setSelectedCar } from "../redux/actions/EquipmentActions";
import type { EquipmentV2DispatchType } from "../redux/store";
import { useEquipmentV2Selector } from "../redux/store";
import { useDispatch } from "../../../../shared-logic/redux/store";

const useEquipmentColourPostal = (): void => {
    const dispatch = useDispatch<EquipmentV2DispatchType>();
    const selectedCar = useEquipmentV2Selector((state) => state.equipment.selectedCar);

    useEffect(() => {
        getPostal().subscribe({
            channel: POSTAL_CHANNEL_T1_GRADE_PAGE_COMPONENTS,
            topic: POSTAL_TOPIC_COLOR_CHANGED,
            callback: (data: { colorGuid: string }) => {
                dispatch(
                    setSelectedCar({
                        modelId: selectedCar.modelId,
                        carId: selectedCar.carId,
                        upholsteryId: selectedCar.upholsteryId,
                        colourId: data.colorGuid,
                    }),
                );
            },
        });
    }, []);
};

export default useEquipmentColourPostal;
